import type {
  ChannelOption,
  MccOption,
  TimePeriodOption,
  ConditionFieldOption,
} from "../types/velocity.types"
import { PROGRAM_OPTIONS, MOCK_MERCHANTS } from '@shared/constants/program-constants'

// Re-export from shared — these are used by shared services/adapters
export { PROGRAM_OPTIONS, MOCK_MERCHANTS }

// ─── Channels ───────────────────────────────────────────────────────
export const CHANNELS: ChannelOption[] = [
  { value: "CP", label: "CP", description: "Card Present" },
  { value: "CNP", label: "CNP", description: "Card Not Present" },
]

// ─── Currencies ─────────────────────────────────────────────────────
export const CURRENCIES = [
  { value: "EUR", label: "EUR" },
  { value: "USD", label: "USD" },
  { value: "GBP", label: "GBP" },
  { value: "BGN", label: "BGN" },
] as const

// ─── MCC Codes ──────────────────────────────────────────────────────
export const MCC_OPTIONS: MccOption[] = [
  { code: "0000", label: "All MCCs" },
  { code: "5411", label: "Grocery Stores" },
  { code: "5812", label: "Restaurants" },
  { code: "5541", label: "Gas Stations" },
  { code: "5912", label: "Drug Stores" },
  { code: "5999", label: "Miscellaneous Retail" },
  { code: "7011", label: "Hotels & Motels" },
  { code: "4511", label: "Airlines" },
  { code: "5311", label: "Department Stores" },
  { code: "5691", label: "Clothing Stores" },
  { code: "7832", label: "Movie Theaters" },
  { code: "5462", label: "Pastry Shops" },
  { code: "5992", label: "Florists" },
]

// ─── Time Periods ───────────────────────────────────────────────────
export const TIME_PERIODS: TimePeriodOption[] = [
  { value: "per_transaction", label: "Per Transaction" },
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
]

export const TIME_PERIOD_LABELS: Record<string, string> = {
  per_transaction: "Per Transaction",
  daily: "Daily",
  weekly: "Weekly",
  monthly: "Monthly",
}

export const TIME_PERIOD_SHORT: Record<string, string> = {
  per_transaction: "Txn",
  daily: "Day",
  weekly: "Wk",
  monthly: "Mo",
}

export const PERIOD_ORDER: Record<string, number> = {
  per_transaction: 0,
  daily: 1,
  weekly: 2,
  monthly: 3,
}

// ─── Actions ────────────────────────────────────────────────────────
export const ACTIONS = ["alert", "decline", "freeze"] as const

// ─── V2 Condition Fields ────────────────────────────────────────────
export const CONDITION_FIELDS: ConditionFieldOption[] = [
  { value: "channel", label: "Channel" },
  { value: "mcc", label: "MCC" },
  { value: "currency", label: "Currency" },
  { value: "accumulator", label: "Accumulator" },
  { value: "period", label: "Period" },
]

export const CONDITION_FIELD_OPTIONS_MAP: Record<string, { value: string; label: string }[]> = {
  channel: CHANNELS.map((c) => ({ value: c.value, label: `${c.value} - ${c.description}` })),
  mcc: MCC_OPTIONS.map((m) => ({ value: m.code, label: `${m.code} ${m.label}` })),
  currency: CURRENCIES.map((c) => ({ value: c.value, label: c.label })),
  accumulator: [
    { value: "TID", label: "TID - Terminal ID" },
    { value: "MID", label: "MID - Merchant ID" },
  ],
  period: TIME_PERIODS.map((p) => ({ value: p.value, label: p.label })),
}

// ─── Aliases ────────────────────────────────────────────────────────
export const PROGRAMS = PROGRAM_OPTIONS
export const MCC_CODES = MCC_OPTIONS
export const MERCHANTS = MOCK_MERCHANTS
export const CONDITION_VALUES_MAP = CONDITION_FIELD_OPTIONS_MAP
